/* eslint-disable no-bitwise */
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BrokenImageDirective } from '@rma/dashboard/generic/ui/broken-image';
import { StaticImageUrlPipe } from '@rma/dashboard/generic/util/pipes/static-image-url';
import { ProfileType } from '@rma/generic/domain/types';
import { ImageOptimisePipe } from '@rma/generic/ng/images';

const DEFAULT_CHARACTER = 'A';

@Component({
  selector: 'rma-avatar',
  templateUrl: './avatar.component.html',
  host: {
    '[class]': 'avatarStyle()',
  },
  imports: [BrokenImageDirective, ImageOptimisePipe, StaticImageUrlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  public readonly avatar = input<string>();
  public readonly name = input.required<string>();
  public readonly backgroundColour = input<string | null>();
  public readonly profileType = input<ProfileType>('Individual');
  public readonly avatarStyle = input<string>('block w-10 h-10 shrink-0 rounded-full text-xl font-bold');

  public readonly letter = computed(() => this.name()?.match(/([A-Za-z])/)?.[0] ?? DEFAULT_CHARACTER);
  public readonly fallbackImage = computed(() => `placeholder/${this.profileType() === 'Individual' ? 'agent' : 'agency'}.jpg`);

  public readonly bg = computed(() => {
    const paddedString = Array(6).fill(this.letter()).join();
    return this.stringToColour(paddedString);
  });

  private stringToColour(str: string): string {
    const hash = str.split('').reduce((accum, curr) => curr.charCodeAt(0) + ((accum << 5) - accum), 0);
    const rgb = [0, 0, 0].map((_, i) => (hash >> (i * 8)) & 255);
    return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
  }
}
